import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api from "../api";
import { REFRESH_TOKEN, ACCESS_TOKEN } from "../constants";
import { useState, useEffect } from "react";

function ProtectedRoute({ children }) {
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        const refreshToken = async () => {
            const refreshToken = localStorage.getItem(REFRESH_TOKEN);
            try {
                const res = await api.post("/api/token/refresh/", {
                    refresh: refreshToken,
                });
                if (res.status === 200) {
                    localStorage.setItem(ACCESS_TOKEN, res.data.access);
                    setIsAuthorized(true);
                } else {
                    setIsAuthorized(false);
                }
            } catch (error) {
                setIsAuthorized(false);
            }
        };

        const auth = async () => {
            const token = localStorage.getItem(ACCESS_TOKEN);
            const refreshtoken = localStorage.getItem(REFRESH_TOKEN);

            if (!token) {
                setIsAuthorized(false);
                return;
            }
            const decoded = jwtDecode(token);
            const tokenExpiration = decoded.exp;
            const now = Date.now() / 1000;

            if (tokenExpiration < now && refreshtoken) {
                await refreshToken();
            } else {
                setIsAuthorized(true);
            }
        };

        auth().catch(() => setIsAuthorized(false));
    }, []);

    if (isAuthorized === null) {
        return <div className="flex items-center justify-center h-screen"><div className="spinner"></div></div>;
    }

    // Bounced visitors land on the landing page itself, not on `/login`.
    // `/login` opens the sign-in dialog on mount, so redirecting there threw a
    // modal at anyone whose token had simply expired — before they had asked
    // for anything. The landing page has its own Log in button; the dialog
    // should be something the visitor opens, not something that opens on them.
    return isAuthorized ? children : <Navigate to="/" replace />;
}
export default ProtectedRoute;
